var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2441 15.2267L15.2441 11.2267M15.2441 11.2267L11.2441 7.22667M15.2441 11.2267H7.24414M21.2441 11.2267C21.2441 16.7495 16.767 21.2267 11.2441 21.2267C5.72129 21.2267 1.24414 16.7495 1.24414 11.2267C1.24414 5.70382 5.72129 1.22667 11.2441 1.22667C16.767 1.22667 21.2441 5.70382 21.2441 11.2267Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0602b9c6dc5501134e0c7094958838ee.svg";
export { ForwardRef as ReactComponent };